import React, { lazy, useRef, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import "./App.css";
import Cookies from 'js-cookie';
import { ToastContainer } from "./utils/toast";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import PrivateRoute from "./components/login/PrivateRoute";
import { SidebarProvider } from "./context/SidebarContext";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GlobalLoadingProvider, registerGlobalLoading } from "./hooks/useGlobalLoading";

const Layout = lazy(() => import("./layout/Layout"))

//const LayoutNew = lazy(() => import("./layout/LayoutNew"))

//const LayoutOld = lazy(() => import("./layout/LayoutOld"))

const Monitor = lazy(() => import("./pages/Monitor"))
const ReturnAcademyPayment = lazy(() => import("./pages/ReturnAcademyPayment"))

const Return = lazy(() => import("./pages/Return"))

const Cancel = lazy(() => import("./pages/Cancel"))

const Redirectcalendar = lazy(() => import("./pages/Redirectcalendar"))

const TermsConditions = lazy(() => import("./pages/TermsConditions"))

const SpinnerRedirectDNS = lazy(() => import("./pages/SpinnerRedirectDNS"))

const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"))

const SignIn = lazy(() => import("./pages/SignIn"))

const SignInAcademia = lazy(() => import("./pages/SignInAcademia"))

const NewSubscription = lazy(() => import("./pages/NewSubscription"))

const SelectAcademia = lazy(() => import("./pages/SelectAcademia"))


const App = () => {


  const currentVersion = useRef(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }
  
    const handleControllerChange = () => {
      console.log("Nuevo Service Worker activo. Recargando...");
      window.location.reload();
    };
  
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      handleControllerChange
    );
  
    return () => {
      navigator.serviceWorker.removeEventListener(
        "controllerchange",
        handleControllerChange
      );
    };
  }, []);

  
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const registration =
          await navigator.serviceWorker.getRegistration();
  
        // No hay Service Worker activo
        if (!registration) {
          return;
        }
  
        const res = await fetch(`/version.json?t=${Date.now()}`, {
          cache: "no-store",
        });
  
        if (!res.ok) return;
  
        const { version } = await res.json();
  
        if (currentVersion.current === null) {
          currentVersion.current = version;
          return;
        }
  
        if (currentVersion.current !== version) {
          console.log(
            `Nueva versión detectada: ${currentVersion.current} → ${version}`
          );
  
          currentVersion.current = version;
  
          await registration.update();
        }
      } catch (e) {
        console.error("No se pudo verificar la versión", e);
      }
    };
  
    checkVersion();
  
    const interval = setInterval(checkVersion, 300000);
  
    return () => clearInterval(interval);
  }, []);

  //cargar MODELO IA
  /*
const engineRef = useRef(null); // local, pero luego lo exponemos globalmente
const [modelLoaded, setModelLoaded] = useState(false);
const [notes, setNotes] = useState(null);


const write_result = (line) => {

window.sharedResult = (window.sharedResult ? window.sharedResult + " " : "") + line;
};

const on_loaded = () => {
console.log("✅ Modelo cargado.");

}

const loadModel = () => {
const user = JSON.parse(localStorage.getItem('userObject') || "{}");

if (window.LLM && user.iamodel) {
  console.log("🔄 Cargando modelo...");
  const url = "/models/" + user.iamodel + ".gguf";

  engineRef.current = new window.LLM(
    "GGUF_CPU",
    url,
    on_loaded,
    write_result,
  );

  engineRef.current.load_worker();

  // Exponer el engine globalmente
  window.engineRef = engineRef;
}
};



useEffect(() => {
const isAndroid = /Android/i.test(navigator.userAgent);

console.log("Es Android " + navigator.userAgent + "--->" + isAndroid)

if (isAndroid) return; // No cargar en Android

const interval = setInterval(() => {
  if (window.LLM && !modelLoaded) {
    loadModel();
    clearInterval(interval);
  }
}, 100);

return () => clearInterval(interval);
}, []);
*/
  //FIN MDELO IA

  return (
    <>
      <ToastContainer />

      <GlobalLoadingProvider>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENTID}>

          <Router>
            <SidebarProvider>
              <AccessibleNavigationAnnouncer />
              <Switch>

                <Route path="/initial" component={Layout} />

                <Route path="/redirectcalendar" component={Redirectcalendar} />

                <Route path="/monitor" component={Monitor} />

                <Route path="/return" component={Return} />

                <Route path="/returnacademy" component={ReturnAcademyPayment} />

                <Route path="/cancel" component={Cancel} />


                <Route path="/signin" component={SignIn} />

                <Route path="/signinacademia" component={SignInAcademia} />

                <Route path="/selectacademia" component={SelectAcademia} />

                <Route path="/termsconditions" component={TermsConditions} />

                <Route path="/privacypolicy" component={PrivacyPolicy} />

                <Route path="/redirectdns" component={SpinnerRedirectDNS} />


                <PrivateRoute path="/">
                  <Route component={Layout} />
                </PrivateRoute>
                <Redirect from="/" to="/initial" exact />
              </Switch>
            </SidebarProvider>
          </Router>

        </GoogleOAuthProvider>
      </GlobalLoadingProvider>
    </>
  );
};

export default App;
